import Keycloak from 'keycloak-js'
const keycloak = new Keycloak(window.REACT_APP_GATEWAY_AUTH_REALM)
export default keycloak
